import React, { useState } from 'react'
import classnames from 'classnames'
import { useDispatch } from 'react-redux'
import ReactSVG from 'react-svg'

import { useConfig } from '../../../hooks/use-config'
import { useProfile } from '../hooks/use-profile'
import Button from '../../../components/button'
import Loading from '../../../../images/neon/loading.svg'
import Imgix from '../../../components/imgix'
import { displayErrorDialog } from '../../../actions'
import { useStyles } from './avatar-selection.styles'

/*
 * Onboarding Step 1:
 * ProfileAvatarSelection allows the user to choose an profile avatar.
 * and proceeds to the next step when the user clicks "NEXT".
 */
const ProfileAvatarSelection = () => {
  const styles = useStyles()
  const dispatch = useDispatch()
  const { appConfig, configLoading, configError } = useConfig()
  const [selectedAvatarId, setSelectedAvatarId] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)
  const { clickHandler } = useProfile()

  const onChange = (id) => {
    setErrorMessage(null)
    setSelectedAvatarId(id)
  }

  const onSubmit = () => {
    if (selectedAvatarId == null) {
      setErrorMessage('Please select a profile avatar to continue')
      return
    }
    clickHandler(selectedAvatarId)
  }

  if (configLoading) {
    return (
      <div className={styles.content}>
        <ReactSVG src={Loading} />
      </div>
    )
  }

  if (configError) {
    dispatch(displayErrorDialog({ message: 'An unexpected error occurred. Please try again later.' }))
    return null
  }

  const avatars = (appConfig.avatars || []).filter(avatar => !avatar.isKidsDefault)

  return (
    <>
      <div className={styles.title}>Choose an avatar</div>
      <div className={styles.subTitle}>You can change this in your profile at any time</div>

      <div className={styles.content}>
        <div className={styles.profileList}>
          {avatars.map(avatar => {
            const { id, uri } = avatar
            const overlayClasses = classnames(styles.itemOverlay, {
              [styles.selected]: id === selectedAvatarId
            })
            return (
              <div key={id} className={overlayClasses} onClick={() => onChange(id)}>
                <Imgix
                  className={styles.avatar}
                  alt="Avatar"
                  src={uri}
                  background
                />
              </div>
            )
          })}
        </div>

        <div className={styles.errorMessage}>{errorMessage}</div>

        <Button
          onClick={onSubmit}
          wrapperClassName={styles.buttonWrapper}
          className={styles.button}
          text="NEXT"
        />
      </div>
    </>
  )
}

export default ProfileAvatarSelection
